module.exports = __webpack_public_path__ + "static/img/liuc2@2x.46576661.png";